/* 
export const defaultSchema = [
	{p:[40,20],c:'hsla(349,100%,75%,1)',s:[0,'50%']},
	{p:[80,0],c:'hsla(108,100%,74%,1)',s:[0,'50%']},
	{p:[0,50],c:'hsla(269,100%,56%,1)',s:[0,'50%']},
	{p:[80,50],c:'hsla(75,100%,93%,1)',s:[0,'50%']},
	{p:[0,100],c:'hsla(60,100%,76%,1)',s:[0,'50%']},
	{p:[80,100],c:'hsla(102,100%,77%,1)',s:[0,'50%']},
	{p:[0,0],c:'hsla(322,100%,70%,1)',s:[0,'50%']}
] */



export const defaultSchema = [
	{p:[40,20],c:'hsla(28,100%,74%,1)',s:[0,'50%']},
	{p:[80,0],c:'hsla(189,100%,56%,1)',s:[0,'50%']},
	{p:[0,50],c:'hsla(355,100%,93%,1)',s:[0,'50%']},
	{p:[80,50],c:'hsla(340,100%,76%,1)',s:[0,'50%']},
	{p:[0,100],c:'hsla(22,100%,77%,1)',s:[0,'50%']},
	{p:[80,100],c:'hsla(242,100%,70%,1)',s:[0,'50%']},
	{p:[0,0],c:'hsla(343,100%,76%,1)',s:[0,'50%']}	
]